var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPressNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44544 22.3363C5.12661 22.3363 4.86166 22.2308 4.65059 22.0197C4.43952 21.8087 4.33398 21.5452 4.33398 21.2293C4.33398 20.9134 4.43952 20.6499 4.65059 20.4388C4.86166 20.2278 5.12592 20.1222 5.44337 20.1222H6.81254V11.6662C6.81254 10.0123 7.30586 8.52213 8.29251 7.19567C9.27918 5.8692 10.58 5.02336 12.195 4.65814V3.86116C12.195 3.36093 12.3711 2.94403 12.7232 2.61046C13.0753 2.27689 13.5009 2.11011 13.9998 2.11011C14.4987 2.11011 14.9242 2.27689 15.2764 2.61046C15.6285 2.94403 15.8045 3.36093 15.8045 3.86116V4.65814C17.4242 5.02336 18.7302 5.8692 19.7226 7.19567C20.7149 8.52213 21.2111 10.0123 21.2111 11.6662V20.1222H22.5632C22.8771 20.1222 23.1405 20.2278 23.3533 20.4388C23.5662 20.6499 23.6726 20.9134 23.6726 21.2293C23.6726 21.5452 23.5662 21.8087 23.3533 22.0197C23.1405 22.2308 22.8771 22.3363 22.5632 22.3363H5.44544ZM14.0044 25.8619C13.3571 25.8619 12.7952 25.6278 12.3186 25.1597C11.842 24.6915 11.6037 24.1269 11.6037 23.4658H16.4029C16.4029 24.1276 16.1682 24.6924 15.6989 25.1602C15.2295 25.628 14.6647 25.8619 14.0044 25.8619Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressNotifications);
export default __webpack_public_path__ + "static/media/pressNotifications.6b53de9b.svg";
export { ForwardRef as ReactComponent };